module.exports = __webpack_public_path__ + "6e8129e0ea0a81cf1e744dbeaf963a9d.png";